export const Types = {
  SET_CARDS_LIST: '@home/SET_CARDS_LIST',
  SET_ACTIVE_TYPE: '@home/SET_ACTIVE_TYPE',
  SET_PROVISIONAL_CARD: '@home/SET_PROVISIONAL_CARD',
};

export function setActiveType(type) {
  return {
    type: Types.SET_ACTIVE_TYPE,
    payload: type,
  };
}

export function setCardsList(list) {
  return {
    type: Types.SET_CARDS_LIST,
    payload: list,
  };
}

export function setProvisionalCard(card) {
  return {
    type: Types.SET_PROVISIONAL_CARD,
    payload: card,
  };
}
